import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navigation, siteInfo } from '@/mocks/site';

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  const LogoTag = isHome ? 'h1' : 'span';

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <div className="flex h-16 w-full items-center justify-between px-4 md:h-20 md:px-8 lg:px-12">
        <Link to="/" className="flex items-center gap-3" aria-label={`${siteInfo.name} 首页`}>
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-spy-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <LogoTag className="font-heading text-lg font-bold tracking-wide text-foreground-950 md:text-xl">
              {siteInfo.name}
            </LogoTag>
            <span className="mt-0.5 hidden text-[11px] tracking-[0.2em] text-foreground-500 sm:block">
              深扒观察室
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navigation.map((item) => {
            const active =
              item.path === '/' ? location.pathname === '/' : location.pathname.startsWith(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`whitespace-nowrap rounded-md px-4 py-2 text-sm transition-colors ${
                  active
                    ? 'bg-primary-100 font-medium text-primary-800'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
          <a
            href="#subscribe"
            className="ml-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            订阅爆料速递
          </a>
        </nav>

        <button
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 md:hidden"
          aria-label={open ? '关闭菜单' : '打开菜单'}
          aria-expanded={open}
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col" aria-label="移动端导航">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-3 text-sm text-foreground-800 hover:bg-background-100"
              >
                {item.label}
              </Link>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-medium text-background-50"
            >
              订阅爆料速递
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}